<template>
  <div class="input-search">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
    >
      <use xlink:href="#icon-search" />
    </svg>
    <input
      class="w-100 text-gray-400"
      type="search"
      :placeholder="placeholder"
      :value="value"
      :disabled="isDisabled"
      @keyup.enter="$emit('input', search);"
      @input="updateValue($event.target.value)"
    >
    <transition-group name="buttonsSearch">
      <button
        v-if="value"
        :key="1"
        type="button"
        aria-label="clear icon"
        class="v-icon--link fas fa-times-circle theme--light primary--text"
        :class="searchOnClick? 'h-100 remove-search': ''"
        @click="onClear"
      />
      <button
        v-if="searchOnClick && value "
        :key="2"
        type="button"
        aria-label="clear icon"
        class="theme--light primary--text h-100 px-3 font-weight-bold search-on-click-btn"
        @click="onSearch"
      >
        <slot name="btnSearch">
          Buscar
        </slot>
      </button>
    </transition-group>
  </div>
</template>
<script>

export default {
  props: {
    value:{
      type: String,
      required:false,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Pesquisar'
    },
    searchOnClick:{
      type:Boolean,
      required:false
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods:{
    onSearch(){
      this.$emit('search', this.value)
      this.$emit('input', this.value)
    },
    onClear(){
      this.updateValue('')
      this.$router.replace({query:{...this.$route.query, search:''}}).catch((err)=>{throw err})
    },
    updateValue: function (value) {
       this.$emit('input', value)
    }
  },
}
</script>
<style scoped>
.buttonsSearch-enter-active, .buttonsSearch-leave-active {
  transition: all 1s;
}
.buttonsSearch-enter, .buttonsSearch-leave-to {
  opacity: 0;
}
.search-on-click-btn{
  right:0px;
  top:0px;
  font-size:16px;
  border-left:1px solid black;
}
.remove-search{
  right:90px;
  top:0px;
  font-size:20px;
}
</style>
